import { Select } from 'antd';
import { SelectContracts } from './SelectContractAis.styled';

interface Props {
 changeContract: (value) => void;
 contracts: Models.Contract[];
 value: string;
}

export default function SelectContractAis({
 changeContract,
 contracts,
 value,
}: Props) {
 return (
  <SelectContracts
   allowClear
   showSearch
   optionFilterProp="children"
   placeholder="Выберите № договора"
   value={value}
   onChange={changeContract}
  >
   {contracts?.map((item) => (
    <Select.Option key={item.aisId} value={item.aisId}>
     {item.resources ? `${item.printNumber} - ${item.resources}` : item.printNumber}
    </Select.Option>
   ))}
  </SelectContracts>
 );
}
